import React from 'react';
import Thumbnail from '../Media/Thumbnail/Thumbnail';
import Link from '../Buttons/Link/Link';
import * as constants from '../../constants';
import { customGaEvent, GA_EVENTS } from '../../utils/ga';

const TourLogo = ({ currentTour, tier, checkLogoURL }) => {
  const { name, styles: {logoId, logoURL, logoAltText }} = currentTour;
  const logoLink = logoId ? checkLogoURL() : 'https://www.concept3d.com';
  const getLinkedAltText = () => {
    if (logoId && logoURL && logoAltText) return logoAltText;
    if (logoId && logoURL) return `${name} homepage`;
    return `Concept3D homepage`;
  };
  const getAltText = () => {
    if (logoId && logoAltText) return logoAltText;
    return `${name} logo`;
  };

    return (
    <div className="logo-wrapper">
      {logoId && !logoURL ? (
        <Thumbnail
          alt={getAltText()}
          height={50}
          logo
          mediaId={logoId}
          mediaType={constants.IMAGES}
          noBackground
          thumbClass="tour-logo thumbonly"
          tourName={currentTour.name}
        />
      ) : (
        tier !== 'starter' && (
          <Link
            handleClick={() =>
              customGaEvent({
                action: GA_EVENTS.LOGO_SELECT,
                label: logoLink,
              })
            }
            href={logoLink}
            newTab
          >
            <Thumbnail
              alt={`${getLinkedAltText()} (opens in new window)`}
              height={100}
              key="tour-logo-thumb"
              logo
              noBackground
              mediaId={logoId || 'LogoHorizontal_reverse_hhagmb.svg'}
              mediaType={constants.IMAGES}
              thumbClass="tour-logo c3d-link"
            />
          </Link>
        )
      )}
    </div>
  );
};

export default TourLogo;
